export default "__VITE_ASSET__DWKI4mVu__"